import { useQuery } from 'react-query';
import api from 'src/services/api';
import useSubscribeStorage from 'src/hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';

const DEVICE_TAGS_QUERY_KEY = 'deviceTags';

const getTags = async ({ customerEnvId, search }) =>
  api.get(`/tag/${customerEnvId}/tags`, {
    params: {
      ...(search ? { search } : {}),
    },
  });

export const useTagOptions = ({ search, enabled = true }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  return useQuery(
    [DEVICE_TAGS_QUERY_KEY, customerEnvId, search],
    () => getTags({ customerEnvId, search }),
    {
      enabled: enabled && !!customerEnvId,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  );
};
